import React, { useState, useEffect, useCallback } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import MobileNav from '../components/MobileNav'
import Breadcrumb from '../components/Breadcrumb'
import WhyusSection from '../components/WhyusSection'
import axios from 'axios';
import Preloader from '../components/Preloader'
import usePageSEO from '../hooks/usePageSEO'

const WhyChooseUs = () => {
  const [loading, setLoading] = useState(true)
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`seo?page=whyus`;
  
  const fetchPagedata = useCallback(async () => {
    return axios.get(apiUrl).then((res) => {
      console.log(res.data);
      setMetaTitle(res.data?.meta_title);
      setMetaDescription(res.data?.meta_description);
    });
  },[]);  

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPagedata();
      setLoading(false);
    }, 1000); // 1 seconds
    return () => clearTimeout(timer);
  }, [fetchPagedata]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  }) 

  return (
    <>
    <div class="page-wrapper">
      <Header />
      <Breadcrumb />
      { loading && ( <Preloader /> )}      
      <WhyusSection />
      <Footer />
    </div>

    <MobileNav />
    </> 
  )
}

export default WhyChooseUs